import React from 'react';
export const ConfigContext = React.createContext({});
export const useConfig = () => React.useContext(ConfigContext);
const ConfigStore = ({
  documentOid,
  isOpen,
  onClose,
  onUpgrade,
  children,
  selectedFolder,
  prefill,
  modalRootId
}) => {
  const [prefillFields, setPrefillFields] = React.useState(prefill ?? {});
  const clearPrefillField = React.useCallback(field => {
    setPrefillFields({
      ...prefillFields,
      [field]: undefined
    });
  }, [prefillFields]);
  return React.createElement(ConfigContext.Provider, {
    value: {
      documentOid,
      isOpen,
      onClose,
      onUpgrade,
      selectedFolder,
      prefill: prefillFields,
      clearPrefillField,
      modalRootId
    }
  }, children);
};
export default ConfigStore;